import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
import ValidateService from "../../../components/ValidateService/ValidateService";

// PAGE
import P244List from "./P244List";
import P244PicList from "./P244PicList";

// SERVICE
import { pAssessmentEvidenceList } from "../../../service/200/P244Service";
import { genPhotoList } from "../../../service/GEN/GenService";

export default function P244() {
    const history = useHistory();

    const op = useRef(null);
    const toggle = (event) => {
        op.current.toggle(event);
    };
    const toast = useRef(null);
    const [loading, setLoading] = useState(false);

    // SEARCH
    const [searchData, setSearchData] = useState(null);

    // DATA
    const [errData, setErrData] = useState(null);
    const [dataTable, setDataTable] = useState([]);
    const [formData, setFormData] = useState({
        assessmentBeginDate: new Date(),
        assessmentEndDate: new Date(),
    });

    // PIC
    const [images, setImages] = useState([]);

    // DIALOG
    const [dialogPic, setDialogPic] = useState({ dialog: false, show: false });

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state && history.location.state.dataSrh) {
                setSearchData({
                    ...searchData,
                    ...history.location.state.dataSrh,
                    userId: dataUserSession().userId,
                });
            } else {
                // setSearchData({
                //     ...searchData,
                //     userId: dataUserSession().userId,
                //     contractNo: "ป.16-1/64",
                //     assessmentNo: 1,
                // });
                history.push("/243");
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        if (searchData !== null) onGetAssessmentEvidenceList();
    }, [searchData]);

    const onGetAssessmentEvidenceList = () => {
        setLoading(true);
        pAssessmentEvidenceList(searchData).then(
            (res) => {
                setLoading(false);
                if (res != undefined) {
                    let temp = [];
                    let index = 0;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                    for (let i = 0; i < temp.length; i++) {
                        if (temp[i].contractNo != null) {
                            setFormData(temp[i]);
                            break;
                        }
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const setValViewForm = (_key) => {
        if (formData != undefined) return formData[_key];
    };

    const handlerDetail = (rowData) => {
        if (rowData.requestNo) {
            history.push({ pathname: "/206", state: { dataSrh: { requestNo: rowData.requestNo } } });
        } else {
            showMessages("error", `ผิดพลาด`, `ไม่พบข้อมูล`);
        }
    };

    const onGetGenPhotoList = (req) => {
        genPhotoList(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    if (res.data.length > 0) {
                        setImages(res.data);
                        setDialogPic({ dialog: true, show: false });
                    } else {
                        showMessages("error", `ผิดพลาด`, `ไม่พบรูปภาพ`);
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                showMessages("error", `เกิดข้อผิดพลาด Status Code: ${err.response.data.status} ${err.response.data.message}`, "");
            }
        );
    };

    const onUploadDialog = (rowData) => {
        const req = {
            photoType: "S002",
            requestNo: rowData.requestNo,
            userId: searchData.userId,
        };
        onGetGenPhotoList(req);
    };

    const handlerGoPage = (obj) => {
        switch (obj.page) {
            case "243":
                history.push({ pathname: `/${obj.page}`, state: { dataSrh: { assessmentNo: searchData.assessmentNo, contractNo: searchData.contractNo } } });
                break;

            default:
                break;
        }
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">ข้อมูลประกอบการประเมิน แบบประเมินที่ 1</h2>
                        <hr /> */}
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2"></div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">เลขที่สัญญา</label>
                                <InputText id="contractNo" type="text" value={setValViewForm("contractNo")} maxLength="20" disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractorName">ผู้รับจ้าง</label>
                                <InputText id="contractorName" type="text" value={setValViewForm("contractorName")} maxLength="200" disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-2"></div>.
                        </div>
                        <br />
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2"></div>
                            <div className="p-field p-col-12 p-md-10">
                                <label htmlFor="">
                                    <h4>
                                        <b>ผลตรวจสอบจากความเห็นของบันทึกตรวจงานประจำวัน</b>
                                    </h4>
                                </label>
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2"></div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="insufficialWorker">ความเห็นแรงงานไม่เพียงพอ ตรวจพบ (ครั้้ง)</label>
                                <InputText id="insufficialWorker" type="text" value={setValViewForm("insufficialWorker")} maxLength={10} disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="insufficialEquipment">ความเห็นเครื่องจักร/เครื่องมือ ต้องปรับปรุง/แก้ไข ตรวจพบ (ครั้้ง)</label>
                                <InputText id="insufficialEquipment" type="text" value={setValViewForm("insufficialEquipment")} maxLength={10} disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-2"></div>
                        </div>
                        <hr />
                        <P244List dataTable={dataTable} setActionDetail={handlerDetail} setActionViewPic={onUploadDialog} />
                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <Button className="p-button-secondary p-button" icon="pi pi-arrow-left" label="กลับหน้าจอหลัก" style={{ width: 170, marginLeft: "5px" }} onClick={() => handlerGoPage({ page: "243" })} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <P244PicList data={images} dialog={dialogPic} setDialog={setDialogPic} toggle={toggle} op={op} />
        </>
    );
}
